import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ListMusic, Headphones } from "lucide-react";
import api, { API } from "@/lib/api";

const base = API.replace(/\/api$/, "");

// Showcase section: most listened shared playlists this week.
export default function PopularPlaylists() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/playlists/top/weekly?days=7&limit=3").then(({ data }) => setItems(data.items)).catch(() => setItems([])); }, []);
  if (!items || items.length === 0) return null;
  return (
    <section className="mt-12" data-testid="showcase-top-playlists">
      <h2 className="font-display text-2xl font-extrabold flex items-center gap-2 mb-6"><ListMusic size={20} className="text-fuchsia-400" /> Popular playlists this week</h2>
      <div className="grid md:grid-cols-3 gap-4">
        {items.map((p, i) => (
          <Link key={p.id} to={p.page_url} className="group rounded-2xl border border-border bg-card p-4 flex gap-4 hover:border-fuchsia-400/50 transition-colors animate-in fade-in slide-in-from-bottom-2" style={{ animationDelay: `${i * 60}ms` }} data-testid={`playlist-card-${p.id}`}>
            <div className="grid grid-cols-2 gap-0.5 w-20 h-20 shrink-0 rounded-xl overflow-hidden border border-border">
              {p.covers.slice(0, 4).map((c, k) => <img key={k} src={`${base}${c}`} alt="" className="w-full h-full object-cover" />)}
              {p.covers.length === 1 && <span className="col-span-1 bg-muted" />}
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="font-display font-bold truncate group-hover:text-fuchsia-300 transition-colors" data-testid={`playlist-card-title-${p.id}`}>{p.title}</h3>
              <p className="text-xs text-muted-foreground mt-0.5 truncate">{p.tracks} track{p.tracks > 1 ? "s" : ""} · {p.artists.slice(0, 3).join(", ")}</p>
              <p className="text-xs font-mono text-muted-foreground mt-2 inline-flex items-center gap-1" data-testid={`playlist-card-plays-${p.id}`}><Headphones size={11} /> {p.week_plays} play{p.week_plays > 1 ? "s" : ""} this week</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
